import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import conf from '@/config/config';

export default {
  methods: {
    async track(mms, page, pageParams) {
      try {
        
        if(!conf.track || conf.track.enable_track != 1)
          return;


        let { app, bid, source, qdata, menuTitle } = pageParams;
        let appinfo = app || { qname: 'jboard' };
        let oldDate = getCookie(`sys-log-${appinfo.qname.replace(/\./g, '')}-${bid.replace(/\./g, '')}`);

        try{
          if(this.isInLastMinutes(oldDate))
            return;
        }catch(err){

        }

        let device = await this.deviceInfo();
        let ypuid = null;
        if(this.$store.getters.isAuthenticated && this.$store.getters.user)
          ypuid = this.$store.getters.user.Uid;
        let currentTime = this.currentTime();

        let payload = {
            App: {
              product: conf.track.product,
              brick: conf.track.brick,
              app_id: app.qname || appinfo.qname,
              click: null
            },
            Meta: {
              Date: currentTime,
              Source: source,
              Menu: menuTitle,
              User: {
                Uid: ypuid
              },
              Device: device,
              Page: {
                Page: `page://${page}`,
                qdata: qdata
              }
            }
        };

          let sysLog = await mms.sendMMS({
            DDN: conf.track.track_ddn,
            topic: conf.track.track_topic,
            payload: payload
          });
          let sysResult;
          if (typeof res == 'object')
            sysResult = sysLog;
          else
            sysResult = sysLog[0];
          if (Array.isArray(sysResult))
            sysResult = sysResult[0];
          // console.log(payload);
          // console.log(sysResult);
          if (sysResult.Reply.ErrMsg == 'OK') {
            let currentDate = this.currentDate(true);
            setCookie(`sys-log-${appinfo.qname.replace(/\./g, '')}-${bid.replace(/\./g, '')}`, currentDate);
          }else{
            console.log(sysResult);
          }



      } catch (error) {
          console.log(error);
      }
    }
  }
}
